import { FechaPdf } from "../../../../shared/utils/fecha";

const tablaGraficos = (data, informe, titulo) => {
    
    var dd = [[{text: titulo, alignment: 'center', border: [false, false, false, false], color: '#003f87',bold: true}]];
        dd.push([{
            image: data,
            fit: [800, 530], 
            // height: 530,
            // width: 800,
            alignment: 'center',
            border: [false, false, false, false]
        }]);
    
    return {
        margin: [0, 0, 0, 0],
        //pageBreak: 'before',
        table: {
            widths: ['100%'],
            body: dd
        }
    };
}

const defaultFooter = (periodo) => {
    return {
        columns: [
            { text: periodo, alignment: "left", style: 'footer'},
            { text: FechaPdf(true), alignment: 'right', style: 'footer'}
        ],
        margin:[10,0,10,10]
    }
  };


export default (data, informe, titulo,logo,periodo) => {

    var docDefinition ={
        //watermark: (esBorrador!==undefined || esBorrador===true) ? { text: 'borrador', opacity: 0.1} : {},
        pageMargins: [ 10, 20, 10, 10 ],
        pageOrientation: 'landscape',
        // info: {
        //     title: 'pdftitulo'
        // },
        background: [{image:logo,alignment:'right', width:50,height:30, margin: [5, 5, 10, 0]}],
        footer: (currentPage, pageCount)=>defaultFooter(periodo),
        content: [       
            tablaGraficos(data, informe, titulo)
        ],
        styles: {
            footer: { fontSize: 6, bold: false, color: '#003f87' }
        },
        defaultStyle : {
            fontSize: 8
        }
    };

    return docDefinition;
   
}